import { useEffect, useRef, useState } from "react";

interface SelectProps<T> {
    options: { text: string, value: T }[];
    extraClass?: string;
    onChange: (value: T) => void;
    defaultValue?: T;
    value?: T;
}

const Select = <T extends object,>({ options, extraClass, onChange, defaultValue, value }: SelectProps<T>) => {
    const selectedOption = options.find((o) => o.value === value) ?? options.find((o) => o.value === defaultValue);
    const [textWidth, setTextWidth] = useState<number>(0);
    const measureRef = useRef<HTMLSpanElement>(null);

    // Medir el texto cuando cambia la opción seleccionada
    useEffect(() => {
        if (measureRef.current) {
            setTextWidth(measureRef.current.offsetWidth);
        }
    }, [selectedOption]);

    const isSelected = (option: SelectProps<T>["options"][number]) => {
        if (defaultValue === undefined || defaultValue === null) {
            return false;
        }
        return defaultValue === option.value;
    };
    return (
        <div style={{ position: "relative" }}>
            <span
                ref={measureRef}
                className="select-text-measure"
            >
                {selectedOption?.text}
            </span>

            <select
                className={extraClass}
                onChange={(x) => onChange(options[parseInt(x.target.value)].value)}
                value={value && options.findIndex((x) => x.value === value)}
                style={textWidth > 0 ? {
                    backgroundPosition: `${textWidth + 12}px center`, // 12px de padding
                } : undefined}
            >
                {options.map((option, index) => (
                    <option key={index + option.text} value={index} selected={isSelected(option)}>
                        {option.text}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default Select;